import { useHistory, useLocation, useParams } from 'react-router';
import urlRoute from '../../common/service/urlRoute';
import { ROUTES } from '../../common/constants/routes';
import carUrlQueryTransformer from '../../common/service/carUrlQueryTransformer';
import { useEffect } from 'react';
import { IBuiltCar } from '../../../../common/model/IBuiltCar';
import stock from '../constants/stock';
import IParams from '../../gqlCustomise/model/IParams';
const equal = require('deep-equal');

export default function useUrlPersistedCustomisation(customisedCar: IBuiltCar): void {
  const { modelId, carId } = useParams<IParams>();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    let currentCustomisedCar = carUrlQueryTransformer.fromQueryString(carId, location);
    currentCustomisedCar = {
      ...customisedCar,
      ...currentCustomisedCar,
    };

    if (!customisedCar || equal(currentCustomisedCar, customisedCar)) {
      return;
    }

    if (!location.pathname.includes(stock.LIST_SUFFIX)) {
      history.replace({
        ...location,
        pathname: urlRoute.createUrl(ROUTES.CONFIGURE, { modelId, carId: customisedCar.carId }),
        search: carUrlQueryTransformer.toQueryString(customisedCar),
      });
    }
  }, [customisedCar, modelId, carId]);
}
